<ngb-accordion [closeOthers]="true">
  <ngb-panel id="panel-{{ index }}" *ngFor="let panel of accordionPanels; index as index">
    <ng-template ngbPanelHeader let-isOpen="opened">
      <button
        ngbPanelToggle
        (click)="isOpen ? trackAccordionClick(panel.event.name, panel.event.Context) : null"
        class="btn cc-btn-transparent d-flex align-items-center justify-content-between w-100 animate-fade-in"
      >
        <span data-test="accordion-title" class="d-flex align-items-center font-weight-medium">
          <i class="cc-icon cc-icon-{{ panel.iconName }} mr-2"></i>{{ panel.titleCode }}
        </span>
        <i class="cc-icon cc-icon-arrow-right" [class.arrow-down]="isOpen"></i>
      </button>
    </ng-template>
    <ng-template ngbPanelContent>
      {{ panel.textContentCode }}
      <br />
      <a
        [href]="panel.learnMoreLink"
        target="_blank"
        rel="noopener noreferrer"
        class="mt-3 btn cc-btn-subtle-blue-helper btn-sm font-weight-medium"
      >
        <i class="cc-icon cc-icon-question mr-1"></i><span>Learn more</span>
      </a>
    </ng-template>
  </ngb-panel>
</ngb-accordion>
